import * as THREE from 'three';
import { PainterContext, TransitionPainter } from '../types';
import { easeInOutCubic } from '../easing';

export function createFadePainter(): TransitionPainter {
  let mesh: THREE.Mesh | null = null;
  let material: THREE.MeshBasicMaterial | null = null;

  return {
    setup({ scene, color }) {
      const geo = new THREE.PlaneGeometry(100, 100);
      material = new THREE.MeshBasicMaterial({ color, transparent: true, opacity: 0 });
      mesh = new THREE.Mesh(geo, material);
      mesh.visible = false;
      scene.add(mesh);
    },
    update(phase, t) {
      if (!mesh || !material) return;
      const eased = easeInOutCubic(t);
      material.opacity = phase === 'exit' ? eased : 1 - eased;
      mesh.visible = true;
    },
    hide() {
      if (mesh) mesh.visible = false;
    },
    dispose() {
      if (mesh) {
        mesh.geometry.dispose();
        (mesh.material as THREE.Material).dispose();
      }
      mesh = null;
      material = null;
    },
  };
}
